import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import { language } from "config";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import { Card, CardContent, CardHeader } from "@material-ui/core";
import Chip from "@material-ui/core/Chip";

function EmailNotificationsSettings(props) {
  const { emails, onChangeEmails } = props;
  const [input, setInput] = useState("");
  const [error, setError] = useState(false);

  const handleTextChange = (e) => {
    setInput(e.target.value);
  };

  const validateEmail = (email) => {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const emailValid = re.test(email);
    return emailValid;
  };

  const onSubmit = () => {
    if (
      validateEmail(input) === false ||
      emails.includes(input.toLowerCase())
    ) {
      setError("Invalid email address");
    } else {
      onChangeEmails([...emails, input.toLowerCase()]);
      setInput("");
      setError(false);
    }
  };

  const onDelete = (email) => {
    const newEmails = emails.filter((e) => e !== email);
    onChangeEmails(newEmails);
  };
  return (
    <div
      style={{
        flexDirection: "column",
        width: "100%",
      }}
    >
      <Card
        style={{
          width: "100%",
          padding: "20px",
        }}
      >
        <CardHeader
          title={language.email_notifications}
          subheader={language.email_notifications_settings_description}
          action={
            <IconButton aria-label="add" onClick={onSubmit}>
              <AddIcon />
            </IconButton>
          }
        />
        <CardContent>
          <TextField
            error={error}
            fullWidth
            id="email-notification"
            label={language.email_notifications_settings_placeholder}
            onChange={handleTextChange}
            value={input}
          />
          <div
            style={{
              marginTop: "20px",
            }}
          >
            {Array.isArray(emails) &&
              emails.map((email, index) => {
                return (
                  <Chip
                    style={{
                      margin: "5px",
                    }}
                    label={email}
                    onDelete={() => onDelete(email)}
                  />
                );
              })}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default EmailNotificationsSettings;
